import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import { formatDateTime } from 'utils';

import { entity as mmsHistories } from '../../ducks/mmsHistories';
import SnippetHistory from './SnippetHistory';
import { actions } from '../../ducks/mmsHistoryList';

class MMSHistory extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    page: PropTypes.number,
    selectedSnippet: PropTypes.string,
    totalPages: PropTypes.number,

    loadPage: PropTypes.func,
    setSelectedSnippet: PropTypes.func,
    setPage: PropTypes.func
  };

  static defaultProps = {
    items: [],
    page: 1,
    selectedSnippet: null,
    totalPages: 1,

    loadPage: () => false,
    setPage: () => false,
    setSelectedSnippet: () => false
  };

  render() {
    const {
      items,
      loadPage,
      page,
      selectedSnippet,
      setPage,
      setSelectedSnippet,
      totalPages
    } = this.props;

    const denormalizedSnippet = items.find((item) => item.id === selectedSnippet);

    function handleError(item) {
      const tooltip = <Tooltip id={item.status}>{
        item.errors.length ? item.errors.map((error, i) => <span key={i}>{error}</span>) : 'Error'
      }</Tooltip>;

      return <React.Fragment>
        <span>{item.status} </span>

        <OverlayTrigger
        placement="right"
        overlay={tooltip}
        title="Error"
      >
        <i className="fa fa-exclamation-triangle red" />
      </OverlayTrigger>
      </React.Fragment>
    }

    function statusToIcon(item) {
      let tooltip = '';
      switch (item.status) {
        case 'sent':
          tooltip = <Tooltip id={status}>Sent</Tooltip>;

          return <OverlayTrigger
            placement="right"
            overlay={tooltip}
            title="Sent"
          >
            <i className="fa fa-check green" />
          </OverlayTrigger>;
        case 'failed':
          return handleError(item);
        case 'undelivered':
          return handleError(item);
        case 'pending':
          tooltip = <Tooltip id={status}>Pending</Tooltip>;

          return <OverlayTrigger
            placement="right"
            overlay={tooltip}
            title="Pending"
          >
            <i className="fa fa-clock-o orange" />
          </OverlayTrigger>;
        default:
          return <p>{item.status}</p>;
      }
    }

    return <SnippetHistory
      displayType="text message"
      header="Text Message History"
      snippets={items}
      loadPage={loadPage}
      page={page}
      selected={denormalizedSnippet}
      onPageChange={setPage}
      onSelect={setSelectedSnippet}
      totalPages={totalPages}
      columns={[
        {
          header: 'Contact',
          value: (item) => <a href={`/contacts/${item.contact_id}`}>{item.contact}</a>
        },
        {
          header: 'On Behalf Of',
          value: (item) => <a href={`/contacts/${item.on_behalf_of_id}`}>{item.on_behalf_of}</a>
        },
        {
          header: 'Number',
          value: 'recipient'
        },
        {
          header: 'Status',
          value: (item) => statusToIcon(item)
        },
        {
          header: 'Created at',
          value: (item) => formatDateTime(item.created_at)
        },
        {
          header: 'Delivered at',
          value: (item) => item.sent_at ? formatDateTime(item.sent_at) : null
        }
      ]}
      showModal={(item, close) =>
        // Show is hard set to true because other components handle the showing and dismissing of this Modal
        <Modal show className="view-mms-modal" backdrop='static' keyboard={false}>
          <Modal.Header>
            <h1 className='modal-title' style={{ display: 'inline-block' }}>View MMS</h1>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => close()} />
          </Modal.Header>
          <Modal.Body>
            <div className="view-mms-field">
              <div className="view-mms-label">
                To:
              </div>
              <div className="view-mms-value">
                <a href={`/contacts/${item.contact}`}>{item.contact}</a>
                &nbsp;({item.recipient})
              </div>
            </div>

            {
              item.on_behalf_of !== item.contact && <div className="view-mms-field">
                <div className="view-mms-label">
                  On behalf of:
                </div>
                <div className="view-mms-value">
                  {item.on_behalf_of}
                </div>
              </div>
            }

            <div className="view-mms-field">
              <div className="view-mms-label">
                Sent at:
              </div>
              <div className="view-mms-value">
                {formatDateTime(item.created_at)}
              </div>
            </div>

            <div className="view-mms-field">
              <div className="view-mms-label">
                Status:
              </div>
              <div className="view-mms-value">
                {item.status}
              </div>
            </div>

            {  item.errors.length > 0 && <div className="view-mms-field">
              <div className="view-mms-label">
                Error:
              </div>
              <div className="view-mms-value">
                {item.errors.map((error, i) => <span key={i}>{error}</span>)}
            </div>
            </div>
            }

            <pre className="view-mms-body">
              {item.body}
            </pre>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={() => close()}>Close</Button>
          </Modal.Footer>
        </Modal>
      }
    />
  }
}

const mapStateToProps = (state) => {
  return {
    items: mmsHistories.all(state, '_paginated'),
    ...state.mmsHistoryList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadPage: (page) => dispatch(mmsHistories.actions.load({ page: page }, '_paginated')),
    setSelectedSnippet: (snippet) => dispatch(actions.setSnippet(snippet && snippet.id)),
    setPage: (page) => dispatch(actions.setPage(page))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MMSHistory);
